/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Muscles_Why_AskInputs */

const en_us2_progress_muscles_why_ask = /** @type {(inputs: Progress_Muscles_Why_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why this weekly target of sets per muscle?`)
};

const pt_br2_progress_muscles_why_ask = /** @type {(inputs: Progress_Muscles_Why_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que essa meta de séries por músculo na semana?`)
};

const es_419_progress_muscles_why_ask = /** @type {(inputs: Progress_Muscles_Why_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué esta meta semanal de series por músculo?`)
};

const pt_pt2_progress_muscles_why_ask = /** @type {(inputs: Progress_Muscles_Why_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê este objetivo semanal de séries por músculo?`)
};

const fr_fr2_progress_muscles_why_ask = /** @type {(inputs: Progress_Muscles_Why_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi cet objectif hebdomadaire de séries par muscle ?`)
};

const de_de2_progress_muscles_why_ask = /** @type {(inputs: Progress_Muscles_Why_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum dieses Wochenziel an Sätzen pro Muskel?`)
};

const it_it2_progress_muscles_why_ask = /** @type {(inputs: Progress_Muscles_Why_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché questo obiettivo settimanale di serie per muscolo?`)
};

/**
* | output |
* | --- |
* | "Why this weekly target of sets per muscle?" |
*
* @param {Progress_Muscles_Why_AskInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_muscles_why_ask = /** @type {((inputs?: Progress_Muscles_Why_AskInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Muscles_Why_AskInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_muscles_why_ask(inputs)
	if (locale === "es-419") return es_419_progress_muscles_why_ask(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_muscles_why_ask(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_muscles_why_ask(inputs)
	if (locale === "de-DE") return de_de2_progress_muscles_why_ask(inputs)
	if (locale === "it-IT") return it_it2_progress_muscles_why_ask(inputs)
	return en_us2_progress_muscles_why_ask(inputs)
});
export { progress_muscles_why_ask as "progress.muscles_why_ask" }